import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProductItemCreateModalUI from './ProductItemCreateModalUI.js'

class ProductItemCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // create product item
      submitted: false,
      // maker
      maker: '',
      makerError: null,
      // item name
      name: '',
      nameError: null,
      // category
      category: '',
      categoryError: null,
      // mrp
      mrp: '',
      mrpError: null
    }
  }

  render() {
    return (
      <ProductItemCreateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // create mode
        createMode={this.props.createMode}
        // maker
        maker={this.state.maker}
        onMakerChange={(event) => { this.setState({ maker: event.target.value }) }}
        makerError={this.state.makerError}
        setMakerError={(event) => { this.setState({ makerError: event.target.value }) }}
        // item name
        name={this.state.name}
        onItemNameChange={(event) => { this.setState({ name: event.target.value }) }}
        nameError={this.state.nameError}
        setNameError={(event) => { this.setState({ nameError: event.target.value }) }}
        // category
        category={this.state.category}
        onCategoryChange={(event) => { this.setState({ category: event.target.value }) }}
        categoryError={this.state.categoryError}
        setCategoryError={(event) => { this.setState({ categoryError: event.target.value }) }}
        // mrp
        mrp={this.state.mrp}
        onPriceChange={(event) => { this.setState({ mrp: event.target.value }) }}
        mrpError={this.state.mrpError}
        setMrpError={(event) => { this.setState({ mrpError: event.target.value }) }}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/inventoryItems`,
      this.onSubmitCallback, {
      maker: this.state.maker,
      name: this.state.name,
      category: this.state.category,
      mrp: this.state.mrp
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'maker':
          this.setState({ makerError: error.message })
          break;
        case 'name':
          this.setState({ nameError: error.message })
          break;
        case 'category':
          this.setState({ categoryError: error.message })
          break;
        case 'mrp':
          this.setState({ mrpError: error.message })
          break;
        default:
      }
    })

    if (response.errorList.length !== 0) {
      this.setState({
        errorList: errorList,
        submitted: false,
      })

      return;
    }

    this.setState({
      successMsg: response.success,
      submitted: false,
      maker: '',
      name: '',
      category: '',
      mrp: ''
    })

    setTimeout(() => {
      this.setState({ successMsg: null })
    }, 2000)

    this.props.onCreateComplete(response.inventoryItem)
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      makerError: null,
      nameError: null,
      categoryError: null,
      mrpError: null,
      submitted: false
    })

    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_create_product_item',
      'c_create',
      'c_cancel',
      'c_maker_name',
      'c_item_name',
      'c_category',
      'c_price'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('prd_itm_crt', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(ProductItemCreateModalSF)
